import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ModalModule } from "@modules/app-modal/modal.module";
import { CoreModule } from "@modules/core/core.module";
import { NotEligibleModalComponent } from "@modules/+new/custody_account/components/custody-account-modal/not-eligible/not-eligible-modal.component";
import { CustodyAccountModule } from "@modules/+new/custody_account/custody_account.module";
import { SumsubStepsInvolvedModalComponent } from "@modules/+new/custody_account/components/custody-account-modal/sumsub-steps-involved/sumsub-steps-involved-modal.component";
import { CamModalComponent } from "@modules/+new/custody_account/features/cam-modal/cam-modal.component";

@NgModule({
	imports: [CoreModule, CommonModule, ModalModule, RouterModule, CustodyAccountModule],
	declarations: [CamModalComponent, NotEligibleModalComponent, SumsubStepsInvolvedModalComponent],
	exports: [RouterModule]
})
export class CamModalModule {}
